<template>
  <div>
    <!-- <Header></Header> -->
    <Top title="Blog" content="Help you to understand our Lastest news and Industry Info" img="#FF9F85" imgMobile="/static/imgs/blog_m.png" v-if="type === 0"></Top>
    <Top title="Help Center" content="Help you to understand our Lastest news and Industry Info" img="#FF9F85" imgMobile="/static/imgs/help_m.png" v-else-if="type === 1"></Top>
    <Top title="" content=""  v-else></Top>
    <div class="entry_bg">
      <div class="entry" v-if="!content">
        <Skeleton type='con'></Skeleton>
      </div>
      <div class="entry" v-else>
        <h1 class="entry-title" v-html="title"></h1>
        <div class="entry-content" v-html="content"></div>
        <div class="entry-content" v-html="bottom"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import Top from './common/top.vue'
import Skeleton from './common/skeleton.vue'

export default {
  name: 'Detail',
  components: {
    Header,
    Footer,
    Top,
    Skeleton
  },
   data () {
    return {
      content: '',
      title: '',
      bottom: '',
      time: '',
      id: '',
      name:'',
      modifiedtime:'',
      type: undefined,
      blogList:["Dropshipping", "Marketing", "Case Studies", "News", "Success Stories", "Special article"],
      metadata:[],
      articleurl:''
    }
  },
  deactivated () {
    document.title = 'AliExpress Dropshipping - ANTDIY'
    this.$destroy()
  },
  created () {
    // console.log(this.$route)
    this.id = this.$route.query.p || this.$route.query.page_id || this.$route.query.paged
    if (!this.id) {
      this.$router.push({
        path: '/home'
      })
    }
    // let blobList = [], helpList = []
    // try {
    //   blobList = JSON.parse(localStorage.getItem('blob')) || []
    //   helpList = JSON.parse(localStorage.getItem('help')) || []
    // } catch (error) {
      
    // }
    // if (blobList.includes(this.id)) {
    //   this.type = 0
    // } else if (helpList.includes(this.id)) {
    //   this.type = 1
    // }
    this.type = this.$route.query.from == 'blog' ? 0 : undefined
    
    this.getData()
  },
  mounted(){
  },
  methods: {
    getData() {
        this.$axios.get(`https://gateway.antdiy.vip/website/posts/${this.id}`)
        .then((res)=>{
          // console.log(res)
          let name
          if (res.data.success && res.data.post) {
            if (!res.data.post.post_content) {
              this.$router.push({
                path: '/home'
              })
            }
            this.content = res.data.post.post_content.replace(/&nbsp;/g, ' ').replace(/ /g," ")
            this.time = new Date(res.data.post.post_date).toISOString()
            this.modifiedtime=new Date(res.data.post.post_modified).toISOString()
            this.title = res.data.post.post_title
            this.name = res.data.post.term_name
            name = res.data.post.post_name
            this.type = this.blogList.indexOf(res.data.post.term_name)==-1 ? 1 : 0 
            document.title = res.data.post.post_title
            window.onload = ()=>{
              document.querySelector("meta[property='og:image']").parentNode.removeChild(document.querySelector("meta[property='og:image']"))
              document.querySelector("meta[property='og:url']").parentNode.removeChild(document.querySelector("meta[property='og:url']"))
              let metar=document.getElementsByTagName('meta')[0]
              let url=`https://www.antdiy.vip/${this.articleurl}.html`
              // 插入link标签
              let oLink = document.createElement('link');
              oLink.setAttribute("rel","canonical")
              oLink.setAttribute("href",url)
              document.getElementsByTagName('head')[0].insertBefore(oLink,metar);
              //插入meta数组对象
              //  console.log(url)
              let entry=document.querySelector('.entry_bg')
              let contentp=entry.getElementsByTagName('p')[0].innerHTML.replace(/<.*?>/g,"")
              let obj=[{ content:this.type==0?"Blog":"Help Center",property:"og:site_name"},{ content:'article',property:"og:type"},{ content:'950',property:"og:image:width"},{ content:'450',property:"og:image:height"},{ content:this.title,property:"og:title"},{ content:contentp,property:"og:description"},{ content:url,property:"og:url"},{ content:'https://www.facebook.com/Antdiytools',property:"article:publisher"},{ content:this.time,property:"article:published_time"},{ content:this.modifiedtime,property:"article:modified_time"},{ content:this.name,property:"article:tag"},{ content:'summary_large_image',name:"twitter:card"},{ content:'Written by',name:"twitter:label1"},{ content:'Filed under',name:"twitter:label2"},{ content:'@AntlinksApps',name:"twitter:site"},{ content:this.title,name:"twitter:title"},{ content:contentp,name:"twitter:description"},{ content:url,name:"twitter:url"},{ content:'ANTDIY',name:"twitter:data1"},{ content:this.name,name:"twitter:data2"}]
              this.metadata=obj
              // 判断图片是否存在
              let image=entry.getElementsByTagName('img')[0].src
              if(image){
                let obj2=[{ content:image,property:"og:image"},{content:image,name:"twitter:image"}]
                this.metadata=this.metadata.concat(obj2)
              }
              // console.log(this.metadata)
              // 循环生成meta标签
              for(let i=0;i<this.metadata.length;i++){
                let oMeta = document.createElement('meta');
                oMeta.content = this.metadata[i].content;
                if(this.metadata[i].property){
                  oMeta.setAttribute("property",this.metadata[i].property)
                }
                if(this.metadata[i].name){
                  oMeta.name = this.metadata[i].name;
                }      
                document.getElementsByTagName('head')[0].insertBefore(oMeta,metar);
              } 

              // head内插入script标签
              let script = document.createElement("script");
                script.async = true;
                script.type = "application/ld+json";
                script.text=
    `{
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id":"https://www.antdiy.vip/${this.articleurl}.html"
      },
    "headline": "${this.articleurl}",
    "description": "${contentp}",
    "image": "${image}",  
    "author": {
      "@type": "Organization",
      "name": "ANTDIY",
      "url": "https://www.antdiy.vip/"
    },  
    "publisher": {
      "@type": "Organization",
      "name": "ANTDIY",
      "logo": {
        "@type": "ImageObject",
        "url": "https://cdn.shopifycdn.net/s/files/applications/3bd2c3b199a99d198e63af4fe1f0f2c6_200x200.png"
      }
    },
    "datePublished": "${this.time}",
    "dateModified": "${this.modifiedtime}"
    }`
                document.head.appendChild(script);
            }
            if (this.blogList.indexOf(res.data.post.term_name) > -1) {
              if (parseInt(this.id)>4531 ) {
                this.getContentByID(res.data.post.term_id)
              } else if ( parseInt(res.data.post.id) > 4531 ) {
                this.getContentByID(res.data.post.term_id, res.data.post.id)
              }
            }
            setTimeout(() => {
              let aList = document.getElementsByTagName('a')
              for (let index = 0; index < aList.length; index++) {
                const element = aList[index];
                element.onclick = (e) => {
                  let id = this.getQuery(e.currentTarget.href, 'p')
                  if (id) {
                    if (this.type == 0) {
                      let blogs = []
                      try {
                        blogs = JSON.parse(localStorage.getItem('blob')) || []
                      } catch (error) {
                        
                      }
                      if (!blogs.includes(id)) {
                        blogs.push(id)
                        localStorage.setItem('blob', JSON.stringify(blogs))
                      }
                    } else {
                      let blogs = []
                      try {
                        blogs = JSON.parse(localStorage.getItem('help')) || []
                      } catch (error) {
                        
                      }
                      if (!blogs.includes(id)) {
                        blogs.push(id)
                        localStorage.setItem('help', JSON.stringify(blogs))
                      }
                    }
                  }
                }
              }
            }, 300)
          } else {
            this.$router.push({
              path: '/home'
            })
          }
          window.onload = ()=>{
            document.querySelector("meta[property='og:image']").parentNode.removeChild(document.querySelector("meta[property='og:image']"))
            document.querySelector("meta[property='og:url']").parentNode.removeChild(document.querySelector("meta[property='og:url']"))
            let metar=document.getElementsByTagName('meta')[0]
            this.articleurl= name || document.querySelector('.entry-title').innerHTML.replace(/<.*?>/g,"").replace(/ /g, '-')
            let url=`https://www.antdiy.vip/${this.articleurl}.html`
            // 插入link标签
            let oLink = document.createElement('link');
            oLink.setAttribute("rel","canonical")
            oLink.setAttribute("href",url)
            document.getElementsByTagName('head')[0].insertBefore(oLink,metar);
            //插入meta数组对象
            //  console.log(url)
            let entry=document.querySelector('.entry_bg')
            let contentp=entry.getElementsByTagName('p')[0].innerHTML.replace(/<.*?>/g,"")
            let obj=[{ content:this.type==0?"Blog":"Help Center",property:"og:site_name"},{ content:'article',property:"og:type"},{ content:'950',property:"og:image:width"},{ content:'450',property:"og:image:height"},{ content:this.title,property:"og:title"},{ content:contentp,property:"og:description"},{ content:url,property:"og:url"},{ content:'https://www.facebook.com/Antdiytools',property:"article:publisher"},{ content:this.time,property:"article:published_time"},{ content:this.modifiedtime,property:"article:modified_time"},{ content:this.name,property:"article:tag"},{ content:'summary_large_image',name:"twitter:card"},{ content:'Written by',name:"twitter:label1"},{ content:'Filed under',name:"twitter:label2"},{ content:'@AntlinksApps',name:"twitter:site"},{ content:this.title,name:"twitter:title"},{ content:contentp,name:"twitter:description"},{ content:url,name:"twitter:url"},{ content:'ANTDIY',name:"twitter:data1"},{ content:this.name,name:"twitter:data2"}]
            this.metadata=obj
            // 判断图片是否存在
            let image=entry.getElementsByTagName('img')[0].src
            if(image){
              let obj2=[{ content:image,property:"og:image"},{content:image,name:"twitter:image"}]
              this.metadata=this.metadata.concat(obj2)
            }
            // console.log(this.metadata)
            // 循环生成meta标签
            for(let i=0;i<this.metadata.length;i++){
              let oMeta = document.createElement('meta');
              oMeta.content = this.metadata[i].content;
              if(this.metadata[i].property){
                oMeta.setAttribute("property",this.metadata[i].property)
              }
              if(this.metadata[i].name){
                oMeta.name = this.metadata[i].name;
              }      
              document.getElementsByTagName('head')[0].insertBefore(oMeta,metar);
            } 

            // head内插入script标签
            let script = document.createElement("script");
              script.async = true;
              script.type = "application/ld+json";
              script.text=`{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id":"https://www.antdiy.vip/${this.articleurl}.html"
    },
  "headline": "${this.articleurl}",
  "description": "${contentp}",
  "image": "${image}",  
  "author": {
    "@type": "Organization",
    "name": "ANTDIY",
    "url": "https://www.antdiy.vip/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "ANTDIY",
    "logo": {
      "@type": "ImageObject",
      "url": "https://cdn.shopifycdn.net/s/files/applications/3bd2c3b199a99d198e63af4fe1f0f2c6_200x200.png"
    }
  },
  "datePublished": "${this.time}",
  "dateModified": "${this.modifiedtime}"
}`
              document.head.appendChild(script);
          }
        })
    },
    getQuery (url, name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = url.substr(url.indexOf("\?")+1).match(reg);
      if (r!=null) return unescape(r[2]); return null;
    },
    //通过tagId获取列表
    getContentByID(id, nowId) {
      let str = ""
      // 不是 Special article 时
      let type = "blog"
      
      if (id!==75) {
        id = "8,92,93,94,102"
        type = "blog"
      }

      this.$axios.get(`https://gateway.antdiy.vip/website/posts?term_ids=${id}&size=10&need_term_name=true&now_ids=${ nowId ? nowId :this.id }`)
        .then((res) => {
          // console.log(res)
          if (res.data.success && res.data.posts) {
            if (res.data.posts.length > 0) {
              str += `<h3>Learn more</h3><ul>`
            }
            res.data.posts.forEach(item => {
              str += `<li><a href="/detail?p=${item.id}&from=${type}" target="_blank">${item.post_title.replace(/&amp;/g,'&').replace(/&nbsp;/g, ' ').replace(/ /g," ")}</a></li>`
            });
            if (res.data.posts.length > 0) {
              str += `</ul>`
            }
            str += `<h3>Join us</h3>
              <ul>
                <li><a rel="noreferrer noopener" href="https://www.facebook.com/Antdiytools/" target="_blank">Join us on Facebook</a></li>
                <li><a rel="noreferrer noopener" href="https://www.instagram.com/antlinks.dropshipping.solution/" target="_blank">Join us on Instagram</a></li>
                <li><a rel="noreferrer noopener" href="https://twitter.com/AntlinksApps" target="_blank">Join us on Twitter</a></li>
                <li><a rel="noreferrer noopener" href="https://www.pinterest.com/antlinks/_created/" target="_blank">Join us on Pinterest</a></li>
                <li><a rel="noreferrer noopener" href="https://www.youtube.com/channel/UCPzpdnQ2TJ_03xxl7QuvzBA" target="_blank">Join us on YouTube</a></li>
              </ul>`
              // console.log(str);
              this.bottom = str;
          }
        });
    },
  },
  watch: {
	  '$route' (to, from) { //监听路由是否变化
		  if(to.query.p != from.query.p){
			  this.id = to.query.p;
			  this.getData();//重新加载数据
		  }
    }
  }  
}
</script>

<style>
  .entry_bg {
    background: #f6f7fa;
  }
  .entry{
    width: 1200px;
    margin: 0 auto;
    padding: 70px 50px;
    background: #FFFFFF;
  }
  .entry-title{
    font-size: 40px;
    line-height: 48px;
    /* font-weight: 300; */
    text-transform: none;
    font-family: "Open Sans", sans-serif;
  }
  .entry-meta{
    color: #595959;
    font-size: 16px;
    line-height: 21px;
    margin-top: 7px;
    font-family: "Open Sans", sans-serif;
  }
  .entry-content{
    margin-top: 34px;
  }
  .entry-content h3{
    font-size: 20px;
    /* margin-bottom: 20px; */
    line-height: 24px;
    /* font-weight: 400; */
    text-transform: none;
  }
  .entry-content h1, .entry-content h2, .entry-content h3, .entry-content h4, .entry-content h5, .entry-content h6{
    margin-bottom: 20px;
  }
  .entry-content h4{
    font-size: 17px;
  }
  .entry-content .wp-block-image{
    margin-bottom: 25px;
  }
  .entry-content .size-large{
    height: auto;
    max-width: 100%;
  }
  figure{
    margin: 0 auto;
    clear: both;
    display: table;
  }
  .entry-content img{
    max-width: 100%;
    height: auto;
  }
  figure figcaption{
    margin: 8px 0 17px;
    display: table-caption;
    caption-side: bottom;
  }
  .entry-content p{
    margin-bottom: 25px;
    font-weight: 400;
    text-transform: none;
    font-size: 17px;
    line-height: 1.5;
    font-family: "Open Sans", sans-serif;
    color: #3a3a3a;
  }
  .entry-content p:last-child{
    margin-bottom: 0;
  }
  .entry-content a, .entry-content a:visited{
    color: #1e73be;
  }
  .entry-content a:hover, .entry-content a:active {
    color: #000000;
  }
  .entry-content ul{
    list-style: disc;
  }
  .entry-content ol{
    list-style: auto;
  }
  .entry-content > ul, .entry-content > ol{
    margin: 0 0 25px 51px;
  }
  .entry-content ul li, .entry-content ol li{
    font-weight: 400;
    text-transform: none;
    font-size: 17px;
    line-height: 1.5;
    font-family: "Open Sans", sans-serif;
    color: #3a3a3a;
  }
  .entry-content ul li>ul{
    margin-left: 25px;
  }
  .entry-content ul li::marker{
    unicode-bidi: isolate;
    font-variant-numeric: tabular-nums;
    text-transform: none;
  }

  @media (max-width: 767px){
    .entry{
      width: 100%;
      padding: .4rem .46rem;
    }
    .entry-content{
      word-break: break-word;
    }
    .entry-title{
      font-size: .6rem;
      line-height: .72rem;
    }
    .entry-meta{
      font-size: .23rem;
      line-height: .3rem;
    }
    .entry-content{
      margin-top: .4rem;
    }
    .entry-content h3{
      font-size: .3rem;
      margin-bottom: .3rem;
      line-height: .36rem;
    }
    .entry-content .wp-block-image{
      margin-bottom: .4rem;
    }
    .entry-content p{
      margin-bottom: .4rem;
      font-size: .24rem;
    }
    .entry-content > ul, .entry-content > ol{
      margin: 0 0 .4rem .5rem;
    }
    .entry-content ul li, .entry-content ol li{
      font-size: .24rem;
    }
    .entry-content ul li>ul{
      margin-left: .4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/detail.vue